import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header>
      <div className="container">
        <nav>
          <Link to="/" className="logo" onClick={closeMenu}>Ansh</Link>
          
          <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
            <span className={isMenuOpen ? 'active' : ''}></span>
            <span className={isMenuOpen ? 'active' : ''}></span>
            <span className={isMenuOpen ? 'active' : ''}></span>
          </button>

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" data-text="Home" onClick={closeMenu}><span>Home</span></Link></li>
            <li><Link to="/projects" data-text="Projects" onClick={closeMenu}><span>Projects</span></Link></li>
            <li><Link to="/services" data-text="Services" onClick={closeMenu}><span>Services</span></Link></li>
            <li><Link to="/about" data-text="About" onClick={closeMenu}><span>About</span></Link></li>
            <li className="mobile-contact"><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
          </ul>
          
          <Link to="/contact" className="btn btn-contact-desktop">Contact <span className="btn-arrow">→</span></Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
